import { UPDATE_DROPDOWN } from "../actions"

const initialDropdownData = {
  MaritalStatus: [],
  Relationship: [],
  LifeClaimantRelationship: [],
  Gender: [],
  PatientType: [],
  WardState: [],
  Nationality: [],
  DescOfDamage: [],
  ClaimType: [{Code: "Illness", Description: "Illness"},{Code: "Accident", Description: "Accident"}, {Code: "Funeral Expenses", Description: "Funeral Expenses"}, {Code: "Third Party Injury Claim", Description: "Third Party Injury Claim"},  {Code: "Third Party Property Claim", Description: "Third Party Property Claim"}],
  IllnessType: [{Code: "Non-Surgical", Description: "Non-Surgical"}, {Code: "Surgical", Description: "Surgical"}],
  AccidentType: [{Code: "Motor vehicle accident", Description: "Motor vehicle accident"}, {Code: "Burn", Description: "Burn"}, {Code: "Electrocution", Description: "Electrocution"}, {Code: "Allergic reaction to an insect bite (except ticks or flea bites)", Description: "Allergic reaction to an insect bite (except ticks or flea bites)"}, {Code: "Bone fracture", Description: "Bone fracture"}, {Code: "Choking", Description: "Choking"}, {Code: "Snake bite toxicity", Description: "Snake bite toxicity"}, {Code: "Traumatic injury or tendon injury", Description: "Traumatic injury or tendon injury"}, {Code: "Bite wound or fight wound abscesses", Description: "Bite wound or fight wound abscesses"}, {Code: "Lacerations or abrasion of tissue, skin or mucous membrane due to physical violence", Description: "Lacerations or abrasion of tissue, skin or mucous membrane due to physical violence"}, {Code: "Others", Description: "Others"}],
}

const dropdownDataReducer = (state = initialDropdownData, action) => {
  switch (action.type) {
    case UPDATE_DROPDOWN:
      switch (action.dropdownName) {
        case "MARITAL_STATUS":
          return { ...state, MaritalStatus: action.dropdownItems }
        case "RELATIONSHIP":
          return { ...state, Relationship: action.dropdownItems }
        case "LIFE_CLAIMANT_RELATIONSHIP":
          return { ...state, LifeClaimantRelationship: action.dropdownItems }
        case "COMMON_GENDER":
          return { ...state, Gender: action.dropdownItems }
        case "CLAIM_COMMON_PATIENT_TYPE":
          return { ...state, PatientType: action.dropdownItems }
        case "CLAIM_COMMON_WARD_STATE":
          return { ...state, WardState: action.dropdownItems }
        case "Nationality":
          return { ...state, Nationality: action.dropdownItems }
        case "CLAIM_GIGA_DAMAGE_DESC":
          return { ...state, DescOfDamage: action.dropdownItems }
        default:
      }
      break
    default:
  }

  return state
}

export default dropdownDataReducer
